import { Button } from "baseui/button"
import { Modal, ModalBody, ModalFooter } from "baseui/modal"

import type { Dispatch, SetStateAction } from "react"
import { Step, CompanyNameStatus } from "./type"

type Props = {
  currentStep: Step
  setCurrentStep: (step: Step) => void
  companyName?: string
  companyNameStatus: CompanyNameStatus
  setCompanyNameStatus: Dispatch<SetStateAction<CompanyNameStatus>>
}

function ConfirmCompanyInfo({
  currentStep,
  setCurrentStep,
  companyName,
  companyNameStatus,
  setCompanyNameStatus,
}: Props) {
  return (
    <>
      <div className="absolute hidden md:block">
        <Modal
          isOpen={currentStep === Step.ConfirmCompanyInfo}
          closeable
          onClose={() => setCurrentStep(Step.InputRegistrationNumber)}
          overrides={{
            Dialog: {
              props: {
                className: "hidden md:block animate-fadeIn",
              },
            },
          }}
        >
          <ModalBody className="pt-6">
            <p className="mb-4 text-center text-lg">
              사업장 이름을 확인해주세요.
            </p>
            <p className="text-center text-2xl font-semibold">
              &ldquo;{companyName}&rdquo;
            </p>
          </ModalBody>
          <ModalFooter className="text-center">
            <Button
              className="min-w-[80px] shadow-none"
              onClick={() => {
                setCompanyNameStatus(
                  companyNameStatus === "CUSTOM"
                    ? "CUSTOM_CONFIRMED"
                    : "AUTOMATIC_CONFIRMED"
                )
                setCurrentStep(Step.InputPhoneNumber)
              }}
            >
              확인
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      <div className="md:hidden">
        <div
          className="fixed left-0 top-0 z-40 h-screen w-screen bg-gray-800 bg-opacity-80 md:hidden"
          style={{ height: "100dvh" }}
          onClick={() => setCurrentStep(Step.InputRegistrationNumber)}
        />
        <div className="animate-slideUp fixed bottom-0 left-0 z-50 flex w-screen flex-col rounded-t-2xl bg-white px-4 pb-6 pt-8 md:hidden">
          <p className="mb-4 text-center text-lg">
            사업장 이름을 확인해주세요.
          </p>
          <p className="mb-6 text-center text-2xl font-semibold">
            &ldquo;{companyName}&rdquo;
          </p>
          <Button
            className="shadow-none"
            onClick={() => {
              setCompanyNameStatus(
                companyNameStatus === "CUSTOM"
                  ? "CUSTOM_CONFIRMED"
                  : "AUTOMATIC_CONFIRMED"
              )
              setCurrentStep(Step.InputPhoneNumber)
            }}
          >
            확인
          </Button>
        </div>
      </div>
    </>
  )
}

export default ConfirmCompanyInfo
